import { SNReportController } from './snreport';

export class SmbController {
  /** @dec SN上报 */
  SNReportController = new SNReportController();
}
